/*
 * File: d:\projects\AutoFiFront\src\Content\Home\HomeCarSlider\HomeCarSlider.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday March 7th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday March 7th 2023 3:48:34 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "Content/Car/CarSingleCarousel/Caroussel.css";
import CarousselStyled from "Theme/Component/CarousselStyled";
import CarCard from "Content/Car/CarCard/CarCard";
import CarService from "Services/Cars/CarService";
import { CarListable } from "Content/Car/CarList/CarList.type";

type CarSliderType = {
    orderList?: {name: string, order: string},
    filters?: string[],
    isPromo?: boolean,
    play?: boolean
};

function CarSlider (props: CarSliderType) {
    const [myCars, setMyCars] = useState([]);
    const [play, setPlay] = useState(false);

    const [windowSize, setWindowSize] = useState([
        window.innerWidth,
        window.innerHeight,]
    );

    const handleWindowResize = () => {
        setWindowSize([window.innerWidth, window.innerHeight]);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    },[]);

    useEffect(()=>{
        const res = CarService.getCars(1, props.filters, props.orderList, props.isPromo);
        res.then(data=>{
        setMyCars(data.cars.map((x: CarListable, index: number) => {
            return <CarCard key={x.id + index} hasEllipsis={true} themeColor={""} IsFav={false} id={x.id}
                        carImg={{
                            url: x.carImg.url,
                            status: x.carInfo.Status,
                            subSection: x.carImg.subSection,
                        }} carCost={{
                            carCost: x.carCost.carCost,
                            rentalCost: undefined,
                            themeColor: undefined
                        }} iconSubSection={{
                            IconSubSection: x.iconSubSection.IconSubSection,
                            id: x.id,
                            themeColor: "",
                            IsFav: undefined
                        }} carInfo={{
                            Brand: x.carInfo.Brand,
                            CirculationDate: x.carInfo.CirculationDate,
                            Energy: x.carInfo.Energy,
                            Gears: x.carInfo.Gears,
                            Mileage: x.carInfo.Mileage,
                            Model: x.carInfo.Model,
                            Version: x.carInfo.Version
                        }}
                    />}
                )
            );
            setPlay(true);
        });
    },[]);

    const getSliderElementSize = (width: number) => {
        return Math.round(40252*(Math.pow(width, -1.02)));
    };

    return(
        <React.Fragment>
                <CarousselStyled bgColor={""} autoPlay={play} showThumbs={false} selectedItem={play ? 1 : 0 } centerMode={true} centerSlidePercentage={getSliderElementSize(windowSize[0])} showArrows={false} width={"100%"} infiniteLoop={true} >
                    {myCars}
                </CarousselStyled>
        </React.Fragment>
    );
}

export default CarSlider;
